/**
 * Subscribe form handler — shared by wpl/subscribe-form and wpl/content-gate.
 * Handles ALL .iam-subscribe-form elements on the page.
 * Fetches a fresh nonce before submission to work with page caching.
 *
 * Cookie/gate unlock only happens for already_subscribed (confirmed).
 * For ok/resent the user must confirm via email first.
 */
// Check cookie on page load — hide form for returning subscribers (cached pages)
if (document.cookie.split(';').some((c) => c.trim().startsWith('iam_subscriber='))) {
	document.querySelectorAll('.iam-subscribe-form-card').forEach((card) => {
		if (card.closest('.iam-content-gate')) return;
		card.style.display = 'none';
	});
}

// Record page-load time so the server-side timing check still works on cached pages
const iamPageLoadTime = Math.floor(Date.now() / 1000).toString();

document.querySelectorAll('.iam-subscribe-form').forEach((form) => {
	if (form.dataset.bound) return;
	form.dataset.bound = '1';

	form.addEventListener('submit', async (e) => {
		e.preventDefault();

		const msgBox = form
			.closest('.iam-subscribe-form-card, .iam-content-gate-cta')
			?.querySelector('.newsletter-msg');
		const btn = form.querySelector('button[type="submit"]');
		const origText = btn ? btn.textContent : '';

		if (btn) {
			btn.disabled = true;
			btn.textContent = 'Sending...';
		}

		const show = (text, type) => {
			if (msgBox) {
				msgBox.className = 'newsletter-msg newsletter-msg--' + type;
				msgBox.textContent = text;
			}
		};

		const warn = (text) => show(text, 'warn');

		try {
			// Fetch a fresh nonce (cached pages may have stale nonces)
			const nonceRes = await fetch('/?iam_newsletter_nonce=1', {
				credentials: 'same-origin',
			});
			const freshNonce = (await nonceRes.text()).trim();

			const fd = new FormData(form);
			if (freshNonce) {
				fd.set('iam_newsletter_nonce', freshNonce);
			}
			// Use page-load time so bot check works on cached pages
			fd.set('iam_form_time', iamPageLoadTime);

			const res = await fetch(form.action, {
				method: 'POST',
				body: fd,
				credentials: 'same-origin',
			});
			const txt = (await res.text()).trim();

			if (txt === 'ok' || txt === 'resent') {
				form.style.display = 'none';
				show(
					'Thanks! Please check your email to confirm your subscription.',
					'success'
				);
			} else if (txt === 'already_subscribed') {
				localStorage.setItem('iam_newsletter_subscribed', '1');
				document.cookie =
					'iam_subscriber=1;path=/;max-age=' +
					60 * 60 * 24 * 365 +
					';SameSite=Lax' +
					(location.protocol === 'https:' ? ';Secure' : '');
				form.style.display = 'none';
				show(
					'You are already subscribed to our newsletter.',
					'info'
				);
				document.dispatchEvent(new CustomEvent('iam:subscribed'));
			} else if (txt === 'blocked') {
				warn('We cannot send emails to this address.');
			} else if (txt === 'rate_limited') {
				warn('Too many attempts. Please try again later.');
			} else if (txt === 'cooldown') {
				warn(
					'We just sent you an email. Please check your inbox (or try again in ~10 minutes).'
				);
			} else {
				show('Something went wrong. Please try again.', 'error');
			}
		} catch {
			show('Network error. Please try again.', 'error');
		} finally {
			if (btn) {
				btn.disabled = false;
				btn.textContent = origText;
			}
		}
	});
});
